<div class="report-container pdf-export">
  <app-reportes-title [pageData]="pageData()"></app-reportes-title>

  <app-report-controls
    [guideId]="'guia-ii'"
    [hasData]="hasData()"
    [isExporting]="isExporting"
    (scenariosChange)="scenarios = $event"
    (hasAppliedFiltersChange)="hasAppliedFilters = $event"
    (analysisModeChange)="analysisMode = $event"
    (exportPdf)="exportToPdf()">
  </app-report-controls>
  <div style="margin:20px"></div> <!-- Se agrega para exportacion a pdf. Se pueda renderizar bien -->

  @if (respondedCountSignal() > 0) {
    @if (!hasAppliedFilters) {
      @let total = (totalEmployees$ | async) ?? 0;
      @let evaluados = respondedCountSignal();
      @let conATS = (conAts$ | async) ?? 0;
      @let cards = (leftCards$ | async);

      <div class="guia-grid">
        <div class="grid-item campaign-cards">
          @if (cards) {
            @for (c of cards; track c.subtitulo) {
              <app-card-campana-component
                [titulo]="c.titulo"
                [subtitulo]="c.subtitulo"
                [icon]="c.icon"
                [colorIcon]="c.colorIcon"
                [class.small-icon]="c.subtitulo === 'Días para finalizar' || 'Activada'">
              </app-card-campana-component>
            }
          }
        </div>

        <div class="grid-item">
          <app-donut-card
            [title]="evaluatedDonutContent().title"
            [primaryLabel]="evaluatedDonutContent().primaryLabel"
            [secondaryLabel]="evaluatedDonutContent().secondaryLabel"
            [primaryCount]="evaluados"
            [totalCount]="total"
            [colors]="evaluatedDonutColors()">
          </app-donut-card>
        </div>

        <div class="grid-item">
          <app-bar-card [results]="ageRangeBarData()" [title]="barCardComponent()?.title ?? ''"></app-bar-card>
        </div>

        <div class="grid-item">
          <app-info-card
            class="ats-card"
            [title]="severeTraumaticEventContent()?.title ?? '' "
            [icon]="atsIcon"
            iconAriaLabel="Información">
            <p>{{ severeTraumaticEventContent()?.descriptionPartOne }}</p>
            <p>{{ severeTraumaticEventContent()?.descriptionPartTwo }}</p>
            <p>{{ severeTraumaticEventContent()?.descriptionPartThree }}</p>
          </app-info-card>
        </div>

        <div class="grid-item">
          <app-donut-card
            [title]="atsDonutContent().title"
            [primaryLabel]="atsDonutContent().primaryLabel"
            [secondaryLabel]="atsDonutContent().secondaryLabel"
            [primaryCount]="conATS"
            [totalCount]="total"
            [colors]="atsDonutColors()">
          </app-donut-card>
        </div>

        <div class="grid-item">
          <app-multi-donut-card [series]="genderDonutData()"
                                [title]="multiDonutCardComponent()?.title ?? ''"></app-multi-donut-card>
        </div>
      </div>
    } @else {
      <app-report-scenario
        [guideId]="'guia-ii'"
        [campaignId]="campaignId()"
        [scenarios]="scenarios"
        (removeScenario)="removeScenario($event)">
      </app-report-scenario>
    }
  } @else {
    <app-empty-state></app-empty-state>
  }
</div>
